import React from 'react';
import './journeyCard.css';
import C2wSuperxJourneyIndexHolder from './indexHolder';

function C2wSuperxJourneyCard( { obj=null, index=null} ) {
  return (
    <div className={` C2wSuperxJourneyCard_ctn C2wSuperxJourneyCard_ctn${index}`}>
      <C2wSuperxJourneyIndexHolder index={index} />
      <div className='C2wSuperxJourneyCard_ctn_heading'>{obj.heading}</div>
      <p className='C2wSuperxJourneyCard_ctn_infopara'>{obj?.infoPara}</p>
    </div>
  )
}

export default C2wSuperxJourneyCard;

